import React, { useEffect } from 'react';

/**
 * Information Component - Redirects to static information.html page
 * This page is a static HTML landing page optimized for SEO and search engines
 * 
 * Author: Markus van Kempen - markus.van.kempen@gmail.com
 * Created: November 2, 2025
 */

const Information = () => {
  useEffect(() => {
    // Redirect to the static HTML page
    window.location.href = '/information.html';
  }, []);

  // Show loading state while redirecting
  return (
    <div style={{
      display: 'flex',
      alignItems: 'center',
      justifyContent: 'center',
      minHeight: '100vh',
      backgroundColor: '#0f172a',
      color: '#e5e5e5',
      fontFamily: 'Arial, sans-serif'
    }}>
      <div style={{ textAlign: 'center' }}>
        <h1>Redirecting to Information Page...</h1>
        <p>If you are not redirected automatically, <a href="/information.html" style={{ color: '#a371f7' }}>click here</a>.</p>
      </div>
    </div>
  );
};

export default Information;

